import { routing } from '@/navigation';
import { AppConfig } from 'next-intl';

export const SUPPORTED_LANGUAGES = routing.locales;

export type SupportedLanguage = AppConfig['Locale'];

export const LOCALE_PARAMS = SUPPORTED_LANGUAGES.map(locale => ({ locale }));

export type LocaleParams = (typeof LOCALE_PARAMS)[number];

export type PromiseLocaleParams = Promise<LocaleParams>;
